module.exports = __webpack_public_path__ + "static/media/am4.d7e774d3.webp";